import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';



export const OnSiteWorkEvent: ITypeSpecificPolicy<types.OnSiteWorkEvent> = {
  fields: {
    dateWorked: dateTimeFieldPolicy()
  }
};
